import React from 'react';
import logoHUDigital from '../../../../assets/logo/logoHUDigital.svg';

import './Header.css';

export function Header() {
  return (
    <div className="headerLandingPage">

      <img
        alt="logo hudigital"
        src={logoHUDigital}
        className="logoHUDigital"
      />
      {/* <p className="version">Versão beta</p> */}

    </div>
  );
}
